// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__v0uz+","link":"navbar_link__SZX2j","active":"navbar_active__EPZsy"};